import { Form, InputNumber, Select, Card, Row, Col, Switch, DatePicker, Tooltip } from "antd";
import { FormInstance } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";

interface PriceInfoCardProps {
    form: FormInstance;
    currencySelectProps: SelectProps;
    updateEffectivePrice: () => void;
}

export const PriceInfoCard = ({ form, currencySelectProps, updateEffectivePrice }: PriceInfoCardProps) => {
    return (
        <Card title="Price Information" style={{ marginBottom: 16 }}>
            <Row gutter={16}>
                <Col span="8">
                    <Form.Item
                        label="Base Price"
                        name={['Price', 'BasePrice']}
                        rules={[{ required: true, message: "Base price is required" }]}
                    >
                        <InputNumber
                            min={0}
                            precision={2}
                            style={{ width: '100%' }}
                            placeholder="Enter base price"
                            onChange={() => updateEffectivePrice()}
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Discount Type"
                        name={['Price', 'DiscountType']}
                        rules={[{ required: true, message: "Discount type is required" }]}
                    >
                        <Select
                            style={{ width: '100%' }}
                            options={[
                                { label: "None", value: "None" },
                                { label: "Percentage", value: "Percentage" },
                                { label: "Fixed Amount", value: "FixedAmount" }
                            ]}
                            onChange={() => updateEffectivePrice()}
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Discount Value"
                        name={['Price', 'DiscountValue']}
                        rules={[{ required: true, message: "Discount value is required" }]}
                    >
                        <InputNumber
                            min={0}
                            precision={2}
                            style={{ width: '100%' }}
                            placeholder="Enter discount value"
                            onChange={() => updateEffectivePrice()}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span="8">
                    <Form.Item
                        label="Effective Price"
                        name={['Price', 'EffectivePrice']}
                        tooltip="Final price after discounts"
                    >
                        <InputNumber
                            readOnly
                            precision={2}
                            style={{ width: '100%', backgroundColor: '#f6ffed' }}
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Currency"
                        name={['Price', 'CurrencyCode']}
                        rules={[{ required: true, message: "Currency is required" }]}
                    >
                        <Select
                            {...currencySelectProps}
                            style={{ width: '100%' }}
                            placeholder="Select currency"
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Default Unit Price"
                        name="DefaultUnitPrice"
                        tooltip="This will be used as the default price for sales"
                    >
                        <InputNumber
                            readOnly
                            precision={2}
                            style={{ width: '100%', backgroundColor: '#f6ffed' }}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span="8">
                    <Form.Item
                        label="Minimum Quantity"
                        name={['Price', 'MinimumQuantity']}
                        rules={[{ required: true, message: "Minimum quantity is required" }]}
                    >
                        <InputNumber
                            min={0}
                            precision={2}
                            style={{ width: '100%' }}
                            placeholder="Minimum order quantity"
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Maximum Quantity"
                        name={['Price', 'MaximumQuantity']}
                        rules={[{ required: true, message: "Maximum quantity is required" }]}
                    >
                        <InputNumber
                            min={0}
                            precision={2}
                            style={{ width: '100%' }}
                            placeholder="Maximum order quantity"
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Price Is Active"
                        name={['Price', 'IsActive']}
                        valuePropName="checked"
                    >
                        <Switch defaultChecked />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span="12">
                    <Form.Item
                        label="Start Date"
                        name={['Price', 'StartDate']}
                        rules={[{ required: true, message: "Start date is required" }]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD"
                        />
                    </Form.Item>
                </Col>

                <Col span="12">
                    <Form.Item
                        label="End Date"
                        name={['Price', 'EndDate']}
                        tooltip="Leave empty if the price doesn't expire"
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD"
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
}; 